
import { Component, Vue, Watch } from 'vue-property-decorator';
// Utils
import Rules from '@/shared/utils/rules.util';
import Mask from '@/shared/utils/masks.util';
// Service
import RecuperacaoService from '@/services/recuperacao.service';

@Component({})
export default class EnviarCodigo extends Vue {
  public cpf = '';

  public rules = Rules;

  public mask = Mask;

  async enviarCodigo() {
    if ((this.$refs.form as HTMLFormElement).validate()) {
      await new RecuperacaoService().enviarCodigo(this.cpf, this);
    }
  }

  voltar() {
    this.$router.go(-1);
  }
}
